export default IconCurrencyRufiyaa => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-currency-rufiyaa" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M20 16h.01" />
  <path d="M4 16c9.5 -4 11.5 -8 14 -9" />
  <path d="M12 8l5 3" />
</svg>`;